exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PriceTextBlock_line-through_3HML {\n  margin-right: 20px;\n\n  text-decoration: line-through;\n}\n", ""]);

// exports
exports.locals = {
	"line-through": "PriceTextBlock_line-through_3HML"
};